import { cn } from '@/lib/utils';

interface AnomalyBadgeProps {
  severity: string;
  className?: string;
}

const severityStyles: Record<string, string> = {
  critical: 'bg-red-100 text-red-700 border-red-200',
  warning: 'bg-amber-100 text-amber-700 border-amber-200',
};

export default function AnomalyBadge({ severity, className }: AnomalyBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border',
        severityStyles[severity] || 'bg-gray-100 text-gray-700 border-gray-200',
        className,
      )}
    >
      {severity}
    </span>
  );
}
